import React from 'react'

import { Box, Collapse, Fade } from '@material-ui/core'
import { isUndefined } from 'lodash'
import PropTypes from 'prop-types'

const toMilliseconds = (seconds) => seconds * 1000

const ToggleBox = ({ collapsed, animationDurationSeconds, fadeEffect, unmountHiddenChildren, children }) => {
  const conditionalProps = {}
  if (!isUndefined(animationDurationSeconds)) {
    conditionalProps.timeout = toMilliseconds(animationDurationSeconds)
  }

  return (
    <Collapse
      in={!collapsed}
      unmountOnExit={unmountHiddenChildren}
      {...conditionalProps}
    >
      {fadeEffect ? (
        <Fade
          in={!collapsed}
          {...conditionalProps}
        >
          <Box>{children}</Box>
        </Fade>
      ) : (
        children
      )}
    </Collapse>
  )
}

ToggleBox.propTypes = {
  collapsed: PropTypes.bool,
  animationDurationSeconds: PropTypes.number,
  fadeEffect: PropTypes.bool,
  unmountHiddenChildren: PropTypes.bool,
  children: PropTypes.node,
}

ToggleBox.defaultProps = {
  collapsed: false,
  fadeEffect: false,
  unmountHiddenChildren: true,
}

export default ToggleBox
